import { render, staticRenderFns } from "./AccountsDatatable.vue?vue&type=template&id=774da4b4&scoped=true&"
import script from "./AccountsDatatable.vue?vue&type=script&lang=js&"
export * from "./AccountsDatatable.vue?vue&type=script&lang=js&"
import style0 from "./AccountsDatatable.vue?vue&type=style&index=0&id=774da4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774da4b4",
  null
  
)

export default component.exports